<template>
  <div class="container">
    <h3>Zaczekaj, tworzymy Ci konto.</h3>
    <div class="d-flex justify-content-center">
      <loading />
    </div>
    <div v-if="error">
      <p>Coś poszło nie tak :(</p>
      <p>Sczegóły błędu: {{ error }}</p>

      <improvement-form :form-type="FormTypes.ERROR" />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ImprovementForm from "@/improvementForms/ImprovementForm";
import { FormTypes } from "@/improvementForms/formTypes";
import Loading from "@/components/Loading";
export default {
  components: { Loading, ImprovementForm },
  mounted() {
    const formData = new FormData();
    formData.set("email", this.socialEmail);
    formData.set("uesrname", this.socialUsername);
    const config = {
      headers: {
        "X-CSRFToken": this.csrf,
        "Content-Type": "multipart/form-data",
      },
    };
    axios
      .post("/accounts/social/signup/", formData, config)
      .then(() => {
        this.$router.push({ name: "index" });
      })
      .catch((reason) => {
        this.error = reason.response.text;
      });
  },
  props: {
    csrf: String,
    socialEmail: String,
    socialEmailError: String,
    socialUsername: String,
    socialUsernameError: String,
  },
  data() {
    return {
      error: "",
      FormTypes,
    };
  },
};
</script>
<style scoped>
.button-gradient {
  padding: 10px;
  color: white;
  background: var(--brand-gradient);
  border-radius: 5px;
  width: 200px;
}
</style>
